import { apiFetch } from "./api";

// Insights events from the live form. A fill session is a random id kept in
// sessionStorage (one per form per browser tab, ended by a successful
// submit). Events are fire-and-forget: they never wait, throw or block the
// form, and each is sent at most once per session (and page). The server
// ignores the owner's own visits and writes the "submit" event itself.

const sessionKey = (formId) => `dforms_session_${formId}`;

function randomId() {
    const bytes = new Uint8Array(16);
    (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(bytes) : bytes.forEach((_, i) => { bytes[i] = Math.floor(Math.random() * 256); });
    return Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
}

export function getSessionId(formId) {
    try {
        let id = sessionStorage.getItem(sessionKey(formId));
        if (!id) {
            id = randomId();
            sessionStorage.setItem(sessionKey(formId), id);
        }
        return id;
    } catch (e) {
        return null; // storage blocked: no tracking
    }
}

export function endSession(formId) {
    try {
        const id = sessionStorage.getItem(sessionKey(formId));
        sessionStorage.removeItem(sessionKey(formId));
        if (id) Object.keys(sessionStorage).filter(k => k.startsWith(`dforms_sent_${formId}_${id}_`)).forEach(k => sessionStorage.removeItem(k));
    } catch (e) {
        // nothing to clean
    }
}

export function sendFormEvent(formId, event, pageId = null) {
    try {
        const sessionId = getSessionId(formId);
        if (!formId || !sessionId) return;
        const sentKey = `dforms_sent_${formId}_${sessionId}_${event}_${pageId || ""}`;
        if (sessionStorage.getItem(sentKey)) return;
        sessionStorage.setItem(sentKey, "1");
        apiFetch(`/api/insights/${formId}/event`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ event, session_id: sessionId, page_id: pageId }),
            keepalive: true,
        }).catch(() => { });
    } catch (e) {
        // analytics never break the form
    }
}
